import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPosteItaliane = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 1096.236 1059.422",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 1096.236,
		height: 1059.422,
		rx: 529.711,
		fill: "#F3D829"
	}), /* @__PURE__ */ _jsxs("g", {
		transform: "matrix(1.0836766 0.0027096 0.00065919053 0.9227862 -805.81517 -508.30015)",
		fill: "#0047BB",
		children: [/* @__PURE__ */ _jsx("path", { d: "m896.69174 1343.4888v-439.15846h142.29216c53.9209 0.00044 89.0696 2.19723 105.4459 6.59037 25.1629 6.5908 46.2321 20.91985 63.2077 42.9872 16.9748 22.06813 25.4624 50.57649 25.4628 85.52509-0.0004 26.9609-4.8933 49.6277-14.6786 68.0006-9.786 18.3734-22.2179 32.8023-37.2955 43.2868-15.0783 10.4849-30.4059 17.4247-45.9828 20.8196-21.1694 4.194-51.8245 6.2909-91.9657 6.2908h-57.8155v165.658zm88.67046-364.86699v124.61799h48.5291c34.9487 0.0002 58.3146-2.2964 70.0976-6.89 11.7825-4.593 21.019-11.7825 27.7095-21.5685 6.69-9.7854 10.0351-21.1688 10.0354-34.1501-0.0003-15.9763-4.6935-29.1571-14.0795-39.5422-9.3865-10.38449-21.2692-16.875-35.6479-19.47157-10.5848-1.99672-31.8537-2.99526-63.8068-2.99562z" }), /* @__PURE__ */ _jsx("path", { d: "m1405.3486 1343.4888v-364.86699h-130.3096v-74.29147h348.9901v74.29147h-130.01v364.86699z" })]
	})]
});
export default SvgPosteItaliane;
